export default __webpack_public_path__ + "static/media/icon-exclamation-red.b7baecf8.svg";